package horcrux.frontend.common.views.screens

import horcrux.frontend.common.GlobalAppState
import horcrux.frontend.common.Route
import horcrux.frontend.common.views.components.containers.ViewWithLogo
import horcrux.frontend.common.views.navigation.ViewWithNavigationBar
import horcrux.frontend.common.withDefaultCSS
import mui.material.Container
import mui.system.sx
import react.FC
import react.Props
import react.dom.html.ReactHTML.p
import web.cssom.pct

external interface ErrorBoundaryScreenProps : Props {
    var message: String
    var globalAppState: GlobalAppState
}

val ErrorBoundaryScreen = FC<ErrorBoundaryScreenProps> { props ->
    ViewWithNavigationBar {
        this.route = Route.ERROR_BOUNDARY
        this.globalAppState = props.globalAppState
        Container {
            this.withDefaultCSS()
            this.sx {
                this.maxWidth = 0.75.pct
            }
            ViewWithLogo {
                p { +props.message }
            }
        }
    }
}
